import React, { useReducer, useEffect } from "react";

import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import async from "async";

import { connection } from "../../../utils/apiConnection.ts";
import { readFile } from "../../../utils/readFile.ts";
import { uploadStateHandler, uploadStateInitialize } from "./uplaodState.ts";
import { ReducerAction } from "./uplaodState.ts";

import "./upload-page.scss";

type sendingData = {
  title: string;
  default_price: string;
  default_weight_from: string;
  default_weight_to: string;
  cat_id: string;
  line_id: string;
  line_title: string;
  img_name: string;
};

const UploadPage: React.FC = () => {
  const [state, dispatch] = useReducer<ReducerAction>(
    uploadStateHandler,
    uploadStateInitialize
  );

  const queue = async.queue((task, callback) => {
    // connection("addproductexcel", task, "superadminapi").then((res) => {
    connection("superadminapi/addproductexcel").then((res) => {
      if (res.status != 1) {
        throw new Error("Can't connect to server!!");
      }
      dispatch({ type: "CompleteRecord" });
      callback();
    });
  }, 20);

  queue.drain(() => {
    Swal.fire({ title: "آیتم(ها) با موفقیت اضافه شدند.", icon: "success" });
  });

  async function fileOnChangeHandler(e) {
    let files = e.target.files;
    dispatch({
      type: "Reset",
    });
    for (let i = 0; i < files.length; i++) {
      let file = await readFile(files[0]);
      let data = XLSX.read(file, {
        type: "binary",
        raw: true,
      });
      for (let sheetName of data.SheetNames) {
        let res = XLSX.utils.sheet_to_json(data.Sheets[sheetName]);
        sendApi(res);
      }
    }
  }

  async function sendApi(
    data: {
      بارکد: string;
      "تصویر 1": string;
      "تصویر 2": string;
      "تصویر 3": string;
      دسته: string;
      زیردسته: string;
      "نام محصول": string;
    }[]
  ) {
    dispatch({
      type: "AddRecord",
      param: data.length,
    });

    let qd = data.map((value) => {
      let img: string =
        value["تصویر 1"] !== ""
          ? value["تصویر 1"]
          : value["تصویر 2"] !== ""
          ? value["تصویر 2"]
          : value["تصویر 3"];
      let d: sendingData = {
        title: value["نام محصول"],
        default_price: 0,
        default_weight_from: 0,
        default_weight_to: 0,
        cat_id: 0,
        line_id: 0,
        line_title: value.زیردسته,
        img_name: img,
      };
      return d;
    });
    queue.push(qd);
  }

  return (
    <div className="upload-page mt-5 d-flex justify-content-center">
      <div className="d-flex flex-column align-items-center">
        <label
          className="btn "
          style={{ cursor: "pointer", userSelect: "none" }}
        >
          لطفا فایل مورد نظر را انتخاب کنید.
          <input
            type="file"
            className="d-none"
            onChange={fileOnChangeHandler}
            multiple
          />
        </label>
        <input
          id="completed-files-range"
          type="range"
          min={0}
          max={state.recordsCount}
          step={1}
          className="range-input mt-3"
          style={{
            backgroundSize: `${
              100 - (state.completedRecordsCount * 100) / state.recordsCount
            }% 100%`,
          }}
          disabled
        />
        <label htmlFor="completed-files-range" className="mt-4 text-center">
          تعداد رکورد های آپلود شده از تب کنونی {state.completedRecordsCount}/
          {state.recordsCount}
        </label>
      </div>
    </div>
  );
};

export default UploadPage;
